import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

const Labels = styled('div')`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 10px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 17px;
	line-height: 20px;
	color: ${hexToRgba(NewStyleColor.White, 75)};
`;

const Track = styled('div')`
	box-sizing: border-box;
	height: 23px;
	margin: 0 10px;
	padding: 10px 0;

	&::after {
		content: '';
		display: block;
		width: calc(100% + 20px);
		height: 3px;
		margin: 0 -10px;
		border-radius: 2px;
		background-color: ${NewStyleColor.Blue450};
	}
`;

const Thumb = styled('div')`
	width: 23px;
	height: 23px;
	border-radius: 50%;
	box-shadow: 0 0 10px 0 ${NewStyleColor.Black};
	background-color: ${NewStyleColor.White};

	&:focus {
		outline: 0;
	}
`;

export {
	Labels,
	Track,
	Thumb,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/RangeSlider/styles.ts